import fetchJSON from '@gaia/utils/fetchJSON';

interface FolderItemMap {
    id: string;
    areas: string[];
    tracks: string[];
    waypoints: string[];
    folders: string[];
}

export default async function getRemoteFolderItemsRecursive(
    folderIds: string | string[]
): Promise<FolderItemMap[]> {
    if (!folderIds || folderIds.length === 0) throw new Error('Cannot get a folder without an id');

    if (!Array.isArray(folderIds)) {
        folderIds = [folderIds];
    }

    try {
        const response = await fetchJSON(
            `/api/objects/folder/recursive-items/?ids=${folderIds.join(',')}`
        );
        return response.map((item: any) => ({
            id: item.id,
            areas: item.area_ids,
            tracks: [...item.track_ids, ...item.route_ids],
            waypoints: item.waypoint_ids,
            folders: item.folder_ids,
        }));
    } catch (e) {
        console.error(`Fetch failed with response ${e}`);
        return folderIds.map((id: string) => ({
            id,
            areas: [],
            tracks: [],
            waypoints: [],
            folders: [],
        }));
    }
}
